<div class="toggle-container">
    <h3 class="toggle-title">{{ title }}</h3>
    <div class="toggle-list">
      <mat-slide-toggle
        *ngFor="let option of options"
        [checked]="values[option.id]"
        [color]="color"
        [disableRipple]="disableRipple"
        [labelPosition]="labelPosition"
        [disabled]="option.disabled || disabled"
        (change)="onToggleChange($event, option.id)"
        class="toggle-item">
        {{ option.label }}
      </mat-slide-toggle>
    </div>
  </div>
  <ng-content select="[info]"></ng-content>
<ng-content select="[validation]"></ng-content>